import React from 'react';

interface IPropsAddNewMnemoWindow {
    closeCM?: Function;
    createCB?: Function;
}

export const AddNewMnemoWindow: React.FC<IPropsAddNewMnemoWindow> = ({ closeCM, createCB }) => {
    let [nameMnemo, setNameMnemo] = React.useState('');

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
            onClick={() => closeCM && closeCM()}>
            <div
                style={{ background: '#ccc', padding: '1em', display: 'flex', flexDirection: 'column' }}
                onClick={(e) => e.stopPropagation()}>
                <div>Имя мнемосхемы</div>
                <input
                    onChange={(e) => {
                        setNameMnemo(e.currentTarget.value);
                    }}
                    autoFocus
                />
                <button
                    onClick={() => {
                        createCB && createCB(nameMnemo);
                    }}>
                    Создать
                </button>
            </div>
        </div>
    );
};
